import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import './AppShell.css';

const AppShell = ({ children, header }) => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const handleToggleSidebar = () => setIsSidebarOpen((prev) => !prev);
    window.addEventListener('mp:sidebar-toggle', handleToggleSidebar);
    return () => window.removeEventListener('mp:sidebar-toggle', handleToggleSidebar);
  }, []);

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className={`mp-app-shell ${isSidebarOpen ? 'has-mobile-sidebar' : ''}`}>
      <Sidebar
        isMobileOpen={isSidebarOpen}
        onNavigateComplete={() => setIsSidebarOpen(false)}
        onClose={() => setIsSidebarOpen(false)}
      />
      {/* Spacer to push content right, since Sidebar is fixed */}
      <div className="mp-app-shell__sidebar-spacer" />
      <button
        type="button"
        className={`mp-shell-backdrop ${isSidebarOpen ? 'is-visible' : ''}`}
        aria-label="Fechar menu lateral"
        onClick={() => setIsSidebarOpen(false)}
      />
      
      <div className="mp-app-main">
        {header && (
          <header className="mp-app-header">
            {header}
          </header>
        )}
        <main className="mp-main-canvas">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AppShell;
